<template>
  <div class="order-allow-deny">
    <div style="overflow: hidden">
      <vs-row>
        <vs-col vs-justify="center" vs-align="center" vs-w="6">
          مدت زمان ارسال سفارش: ( دقیقه )
          <vs-input v-model="preparationTime" class="w-100 mt-1" />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getMoment } from "../../helpers/Functions";

export default {
  name: "PreparationTime",
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    getTime() {
      const { preparationTime } = this;
      const time = getMoment()
        .add(preparationTime, "minute")
        .format("YYYY-MM-DD HH:mm:ss");
      return time;
    },
  },
  data() {
    return {
      preparationTime: "45",
    };
  },
};
</script>
